import { Card, CardHeader } from '@wordpress/components';
import { Fragment, useState, useMemo, RawHTML } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import { useEntityRecords } from '@wordpress/core-data';
import { DataViews, filterSortAndPaginate } from '@wordpress/dataviews/wp';
import { decodeEntities } from '@wordpress/html-entities';
import { deletePost } from '@wordpress/fields';
import { dateI18n, getDate, getSettings } from '@wordpress/date';

const defaultLayouts = {
	table: {
		layout: {
			primaryField: 'id',
		},
	},
};

const Logs = () => {
	const [ view, setView ] = useState( {
		type: 'table',
		page: 1,
		perPage: 10,
		sort: {
			field: 'date',
			direction: 'desc',
		},
		search: '',
		filters: [],
		titleField: 'title',
		fields: [ 'id', 'content', 'date' ],
		layout: defaultLayouts.table.layout,
	} );

	const { records: logs, isResolving: isLoadingLogs } = useEntityRecords(
		'postType',
		'popper_log',
		{ per_page: -1 }
	);

	const fields = useMemo(
		() => [
			{
				id: 'id',
				label: __( 'ID' ),
				enableGlobalSearch: true,
			},
			{
				header: __( 'Title' ),
				id: 'title',
				getValue: ( { item } ) => item.title.rendered,
				render: ( { item } ) => {
					return decodeEntities(
						item.title?.rendered || 'Log #' + item.id
					);
				},
				enableGlobalSearch: true,
				enableHiding: false,
				enableSorting: true,
			},
			{
				header: __( 'Content' ),
				id: 'content',
				getValue: ( { item } ) => item.content.raw,
				render: ( { item } ) => {
					return (
						<RawHTML className="field-content">
							{ decodeEntities( item.content.raw ) }
						</RawHTML>
					);
				},
				enableHiding: false,
				enableSorting: false,
				maxWidth: '240px',
				width: '240px',
			},
			{
				header: __( 'Date' ),
				id: 'date',
				render: ( { item } ) => {
					const formattedDate = dateI18n(
						getSettings().formats.datetimeAbbreviated,
						getDate( item.date )
					);
					return <time>{ formattedDate }</time>;
				},
			},
		],
		[]
	);

	const { data: processedData, paginationInfo } = useMemo( () => {
		return filterSortAndPaginate( logs, view, fields );
	}, [ view, logs, fields ] );

	const { isEligible, ...deleteAction } = deletePost;

	const actions = [
		deleteAction,
		{
			id: 'delete',
			label: 'Delete item',
			isPrimary: true,
			supportsBulk: true,
			hideModalHeader: true,
			modalSize: 'fill',
			RenderModal: ( { items, closeModal } ) => {
				return <p>Ciao</p>;
			},
		},
	];

	return (
		<Fragment>
			<Card>
				<CardHeader size="small">
					<b>{ __( 'Logs', 'popper' ) }</b>
				</CardHeader>

				<div className="popper-content2">
					<DataViews
						paginationInfo={ paginationInfo }
						fields={ fields }
						actions={ actions }
						data={ processedData }
						isLoading={ isLoadingLogs }
						view={ view }
						onChangeView={ setView }
						defaultLayouts={ defaultLayouts }
					/>
				</div>
			</Card>
		</Fragment>
	);
};

export default Logs;
